import { render } from "./WhatOurCustomerSays.vue?vue&type=template&id=c4b909b4&scoped=true"
import script from "./WhatOurCustomerSays.vue?vue&type=script&lang=js"
export * from "./WhatOurCustomerSays.vue?vue&type=script&lang=js"

import "./WhatOurCustomerSays.vue?vue&type=style&index=0&id=c4b909b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4b909b4"]])

export default __exports__